import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../cn';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'md' | 'sm';
  icon?: ReactNode;
  iconOnly?: boolean;
  loading?: boolean;
  block?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', icon, iconOnly, loading, block, className, children, disabled, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'bf-btn',
        variant !== 'secondary' && `bf-btn--${variant}`,
        size === 'sm' && 'bf-btn--sm',
        iconOnly && 'bf-btn--icon',
        block && 'bf-btn--block',
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="bf-spinner" aria-hidden /> : icon}
      {!iconOnly && children}
      {iconOnly && <span className="bf-sr-only">{children}</span>}
    </button>
  );
});

export function Spinner({ label = 'Cargando' }: { label?: string }) {
  return (
    <span role="status" style={{ display: 'inline-flex' }}>
      <span className="bf-spinner" aria-hidden />
      <span className="bf-sr-only">{label}</span>
    </span>
  );
}
